import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import TrendingDownIcon from '@material-ui/icons/TrendingDown';

const styles = theme => ({
    executionRow: {
        backgroundColor: theme.palette.secondary.main,
    },
    executionIcon: {
        color: theme.palette.secondary.contrastText,
    },
    executionHeading: {
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.secondary.contrastText,
    },
    rowIconButtonRoot: {
        height: 40
    }
});

class ExecutionComponent extends React.Component {

    render() {

        const { classes, execution, children, colSpan } = this.props;

        return (
            <TableBody>
                <TableRow classes={{ root: classes.executionRow }} >
                    <TableCell className="icon-cell"><TrendingDownIcon className={classes.executionIcon} /></TableCell>
                    <TableCell colSpan={colSpan}>
                        <Typography className={classes.executionHeading}>Execution Package</Typography>
                    </TableCell>
                    <TableCell colSpan={colSpan}>
                        <Typography className={classes.executionHeading}>{execution.status}</Typography>
                    </TableCell>
                    <TableCell colSpan={colSpan}>
                        <Typography className={classes.executionHeading}>{execution.statusMessage}</Typography>
                    </TableCell>
                    <TableCell></TableCell>
                </TableRow>
                {children}
            </TableBody>
        )
    }
}

ExecutionComponent.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ExecutionComponent);


// WEBPACK FOOTER //
// ./src/Components/Presentation/ETL/ExecutionHistory/ExecutionComponent.js